var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "avue-logo" },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.keyCollapse
          ? _c("img", {
              key: "0",
              staticClass: "avue-logo_fold",
              attrs: { src: "/img/" + _vm.getLogoUrl[0] + ".png", alt: "" },
              on: { click: _vm.goIndex },
            })
          : _vm._e(),
      ]),
      _c("transition-group", { attrs: { name: "fade" } }, [
        !_vm.keyCollapse
          ? _c("img", {
              key: "1",
              staticClass: "avue-logo_unfold",
              attrs: { src: "/img/" + _vm.getLogoUrl[1] + ".png", alt: "" },
              on: { click: _vm.goIndex },
            })
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }